import React, { useEffect } from "react";
import { useDeepResearchService } from "../../adapters/deep-research/state/hooks/useDeepResearchService.tsx";
import { useTermsAndConditionsState } from "../../adapters/deep-research/state/hooks/stateHooks";
import { useFeatureFlagValue } from "../../config/FeatureFlagManager/hooks";
import { TermsAndConditionsGuard } from "./TermsAndConditionsGuard";

export interface ConnectedTermsAndConditionsGuardProps {
  children: React.ReactNode;
}

export const ConnectedTermsAndConditionsGuard: React.FC<
  ConnectedTermsAndConditionsGuardProps
> = ({ children }) => {
  const enableTermsAndConditions = useFeatureFlagValue(
    "enableTermsAndConditions",
  );
  const appService = useDeepResearchService();
  const termsState = useTermsAndConditionsState();

  useEffect(() => {
    // Only check terms status if feature flag is enabled
    if (enableTermsAndConditions) {
      appService.refreshTermsAndConditions();
    }
  }, [appService, enableTermsAndConditions]);

  const handleAcceptTerms = () => {
    appService.acceptTermsAndConditions();
  };

  return (
    <TermsAndConditionsGuard
      enableTermsAndConditions={enableTermsAndConditions}
      termsStatus={termsState.status}
      termsContent={termsState.content}
      isLoadingTerms={termsState.loading}
      error={termsState.error}
      isAccepting={termsState.accepting}
      onAcceptTerms={handleAcceptTerms}
    >
      {children}
    </TermsAndConditionsGuard>
  );
};
